import React, { useEffect, useState, useMemo } from "react";
import { Formik, Form, Field } from "formik";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { Container, Input, Table } from "reactstrap";
import { useNavigate } from "react-router-dom";
import "../../share/form.css";
import { BsPlusCircle } from "react-icons/bs";
import "../../share/TableLanding.css";
import CreateTableHaveFooterComponent from "../../share/CreateTableHaveFooterComponent";
import { FiEdit } from "react-icons/fi";
import Select from "react-select";
import { NumberWithCommas } from "../../share/NumberWithCommas";
import { NumericFormat } from "react-number-format";
import { CustomInputNumeric } from "../../share/CustomInputNumeric";
import Modal from "react-modal";
import { CgClose } from "react-icons/cg";
import { GetVMdDept } from "../../share/api/MasterDataApi";

export function BudgetYearLimitDetailComponent() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("userData"));

  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [deptsData, setDeptsData] = useState([]);
  const [selectedBudgetYear, setSelectedBudgetYear] = useState(null);
  const [loading, setLoading] = useState(false);
  const [provincialAllocations, setProvincialAllocations] = useState([]);
  const [Condition, setCondition] = useState([]);

  const modalToggle = () => setModal(!modal);

  const getCustomStyles = (isSupport10 = false) => ({
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      maxWidth: isSupport10 ? "85vw" : "75vw",
      width: "100%",
      maxHeight: isSupport10 ? "90vh" : "50vh",
      overflow: isSupport10 ? "auto" : "hidden",
      padding: "2rem",
      borderRadius: "16px",
      boxShadow: "0 5px 20px rgba(0,0,0,0.2)",
      minHeight: isSupport10 ? "90vh" : "40vh",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
  });

  const conditionOptions = Condition?.map((item) => ({
    value: item.supportTypeId,
    label: item.supportDetail,
  }));

  const budgetYearOptions = useMemo(() => {
    const years = [...new Set(data?.map((item) => item.budgetYear))];
    const yearOptions = years.sort().map((year) => ({ value: year, label: year }));
    return [{ value: "", label: "ทั้งหมด" }, ...yearOptions];
  }, [data]);

  const filteredData = useMemo(() => {
    if (!selectedBudgetYear || selectedBudgetYear.value === "") return data;
    return data?.filter((item) => item.budgetYear === selectedBudgetYear.value);
  }, [data, selectedBudgetYear]);

  useEffect(() => {
    getCondition();
    getYearBudgetList();
    GetVMdDept({ setDeptsData, setLoading });
  }, []);

  useEffect(() => {
    if (budgetYearOptions.length > 0 && !selectedBudgetYear) {
      setSelectedBudgetYear({ value: "", label: "ทั้งหมด" });
    }
  }, [budgetYearOptions]);

  async function getYearBudgetList() {
    try {
      const response = await fetch("/api/Support/getyearbudgetlist");
      const d = await response.json();
      setData(d.dataenum);
    } catch (e) {
      // console.log("err => " + e);
    }
  }

  async function getCondition() {
    try {
      const response = await fetch("/api/Support/getSupportTypeList");
      const d = await response.json();
      setCondition(d.dataenum);
    } catch (e) {
      // console.log("err => " + e);
    }
  }

  const formInitialValues = {
    budgetYear: "",
    amountlimit: "",
    Updateby: user.fullName,
    Createby: user.fullName,
    update: "0",
    budgetId: "",
    supportConditionId: "",
    provincialAllocations: [],
  };

  const validateSchema = Yup.object().shape({});

  function getInitialProvinceList() {
    return deptsData
      ?.filter((item) => item.value !== "01")
      .map((dept) => ({
        deptId: dept.value,
        deptName: dept.label,
        amount: "",
        personTotal: "",
      }));
  }

  const openAddModal = (resetForm, setValues) => {
    const initial = getInitialProvinceList();

    resetForm();

    setValues({
      budgetYear: "",
      amountlimit: "",
      Updateby: user.fullName,
      Createby: user.fullName,
      update: "0",
      budgetId: "",
      supportConditionId: "",
      provincialAllocations: initial,
    });

    setProvincialAllocations(initial);
    modalToggle();
  };

  const closemodalToggle = (resetForm) => {
    resetForm();
    const initial = getInitialProvinceList();
    setProvincialAllocations(initial);
    modalToggle();
  };

  async function onSubmit(values, action) {
    let formData = new FormData();
    Object.entries(values).forEach(([key, value]) => {
      if (key === "provincialAllocations") return;
      formData.append(key, value);
    });

    formData.append(
      "provincialAllocations",
      JSON.stringify(provincialAllocations)
    );

    try {
      let res = await fetch("api/Support/savesupportbudgetyear", {
        method: "POST",
        body: formData,
      });

      let resJson = await res.json();

      if (resJson.status === 1) {
        Swal.fire({
          icon: "success",
          title: "บันทึกสำเร็จ",
          confirmButtonColor: "#0A66C2",
        }).then(() => {
          modalToggle();
          action.resetForm();
          window.location.reload();
        });
      } else {
        Swal.fire({
          icon: "warning",
          title: "บันทึกไม่สำเร็จ",
          confirmButtonColor: "#0A66C2",
        });
      }
    } catch (e) {
      // console.log(e);
    }
  }

  async function onEdit(id, setFieldValue) {
    const found = data.find((x) => x.budgetAmountId == id);

    setFieldValue("budgetYear", found.budgetYear);
    setFieldValue("amountlimit", found.amount);
    setFieldValue("budgetId", id);
    setFieldValue("supportConditionId", Number(found.supportTypeId));
    setFieldValue("update", "1");

    setProvincialAllocations(found?.provincialAllocations ?? []);
    setFieldValue("provincialAllocations", found?.provincialAllocations ?? []);

    modalToggle();
  }

  return (
    <Container>
      <Formik
        initialValues={formInitialValues}
        validationSchema={validateSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({
          values,
          handleChange,
          handleBlur,
          setFieldValue,
          setValues,
          resetForm,
          errors,
          touched,
        }) => {
          const myCustomStyles = getCustomStyles(
            values.supportConditionId === 10
          );

          const handleAllocationChange = (index, key, newValue) => {
            setProvincialAllocations((prev) =>
              prev.map((row, i) =>
                i === index ? { ...row, [key]: newValue } : row
              )
            );
          };

          const COLUMNS = [
            {
              Header: "ลำดับ",
              accessor: (_row, i) => i + 1,
              enableRowSpan: true,
            },
            {
              Header: "ปีงบประมาณ",
              accessor: "budgetYear",
            },
            {
              Header: "หัวข้อประกาศ",
              accessor: "supportAnnouceDetail",
              Cell: ({ value }) => <div>{value}</div>,
            },
            {
              Header: "วงเงิน",
              accessor: "amount",
              Cell: ({ row }) => (
                <div className="d-flex justify-content-end">
                  {NumberWithCommas(row.original.amount)}
                  <FiEdit
                    className="mx-3 style-icon"
                    onClick={() => onEdit(row.original.budgetAmountId, setFieldValue)}
                  />
                </div>
              ),
              Footer: ({ data }) => {
                const sum = data.reduce(
                  (acc, row) => acc + Number(row.amount ?? 0),
                  0
                );
                return (
                  <div className="d-flex">
                    <div className="text-center">รวม</div>
                    <div className="text-right w-100">
                      {NumberWithCommas(sum)}
                    </div>
                  </div>
                );
              },
            },
          ];

          return (
            <>
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <label className="me-3">ปีงบประมาณ</label>
                  <Select
                    options={budgetYearOptions}
                    value={selectedBudgetYear}
                    onChange={(v) => setSelectedBudgetYear(v)}
                    isClearable
                    placeholder="เลือกปีงบประมาณ"
                    classNamePrefix="react-select"
                  />
                </div>

                {user.roldId === "4" && (
                  <button
                    onClick={() => openAddModal(resetForm, setValues)}
                    type="button"
                    className="btn-green p-2"
                  >
                    <BsPlusCircle className="mx-1" />
                    เพิ่มข้อมูล
                  </button>
                )}
              </div>

              <CreateTableHaveFooterComponent
                column={COLUMNS}
                dataInput={filteredData}
                showEntrie={false}
                showPage={true}
              />

              <Modal
                isOpen={modal}
                onRequestClose={() => closemodalToggle(resetForm)}
                style={myCustomStyles}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <h3 className="w-100" style={{ color: "#0E527E" }}>
                    เพิ่มข้อมูลประจำปีงบประมาณ
                  </h3>
                  <CgClose
                    onClick={() => closemodalToggle(resetForm)}
                    className="style-iconmodal"
                  />
                </div>

                <hr />

                <div className="px-4 mt-4">
                  <div className="row mb-4">
                    <div className="col-12">
                      <label>หัวข้อประกาศ</label>
                      <Field name="supportConditionId">
                        {({ field }) => (
                          <Select
                            name={field.name}
                            onBlur={field.onBlur}
                            onChange={({ value }) =>
                              setFieldValue(field.name, value)
                            }
                            options={conditionOptions}
                            placeholder="กรุณาเลือก"
                            value={conditionOptions.find(
                              (option) => option.value == field.value
                            )}
                          />
                        )}
                      </Field>
                    </div>
                  </div>

                  <div className="row g-3">
                    <div className="col-md-6">
                      <label>ปีงบประมาณ</label>
                      <Field name="budgetYear">
                        {({ field }) => (
                          <Input
                            {...field}
                            placeholder="2567"
                            className="form-control rounded-pill text-center"
                          />
                        )}
                      </Field>
                    </div>

                    <div className="col-md-6">
                      <label>วงเงินช่วยเหลือ</label>
                      <Field name="amountlimit">
                        {({ field }) => (
                          <NumericFormat
                            {...field}
                            thousandSeparator=","
                            decimalScale={2}
                            allowNegative={false}
                            onValueChange={(val) =>
                              setFieldValue(field.name, val.value)
                            }
                            customInput={CustomInputNumeric}
                            className="form-control rounded-pill text-end"
                          />
                        )}
                      </Field>
                    </div>
                  </div>
                </div>

                {values.supportConditionId === 10 &&
                  provincialAllocations.length > 0 && (
                    <div className="mt-4">
                      <div
                        style={{ maxHeight: "60vh", overflowY: "auto" }}
                        className="table-responsive border rounded"
                      >
                        <Table bordered className="table-modern align-middle">
                          <thead>
                            <tr className="text-center">
                              <th>ลำดับ</th>
                              <th>จังหวัด</th>
                              <th>วงเงินจัดสรร</th>
                              <th>จำนวนคน</th>
                            </tr>
                          </thead>
                          <tbody>
                            {provincialAllocations.map((p, i) => (
                              <tr key={p.deptId}>
                                <td className="text-center">{i + 1}</td>
                                <td>{p.deptName}</td>
                                <td>
                                  <Field name={`provincialAllocations[${i}].amount`}>
                                    {({ field }) => (
                                      <NumericFormat
                                        {...field}
                                        thousandSeparator=","
                                        decimalScale={2}
                                        allowNegative={false}
                                        onValueChange={(val) => {
                                          setFieldValue(field.name, val.value);
                                          handleAllocationChange(
                                            i,
                                            "amount",
                                            val.value
                                          );
                                        }}
                                        customInput={CustomInputNumeric}
                                        className="form-control rounded-pill text-end"
                                      />
                                    )}
                                  </Field>
                                </td>
                                <td>
                                  <Field
                                    name={`provincialAllocations[${i}].personTotal`}
                                  >
                                    {({ field }) => (
                                      <NumericFormat
                                        {...field}
                                        thousandSeparator=","
                                        allowNegative={false}
                                        onValueChange={(val) => {
                                          setFieldValue(field.name, val.value);
                                          handleAllocationChange(
                                            i,
                                            "personTotal",
                                            val.value
                                          );
                                        }}
                                        customInput={CustomInputNumeric}
                                        className="form-control rounded-pill text-end"
                                      />
                                    )}
                                  </Field>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                          <tfoot>
                            <tr className="fw-bold">
                              <td colSpan={2} className="text-end">
                                รวม
                              </td>
                              <td className="text-end">
                                {NumberWithCommas(
                                  provincialAllocations
                                    .reduce(
                                      (s, p) =>
                                        s + parseFloat(p.amount || "0"),
                                      0
                                    )
                                    .toFixed(2)
                                )}
                              </td>
                              <td className="text-end">
                                {NumberWithCommas(
                                  provincialAllocations.reduce(
                                    (s, p) =>
                                      s + parseFloat(p.personTotal || "0"),
                                    0
                                  )
                                )}
                              </td>
                            </tr>
                          </tfoot>
                        </Table>
                      </div>
                    </div>
                  )}

                <div className="d-flex justify-content-evenly text-center w-100">
                  <Form className="d-flex justify-content-evenly w-100">
                    <button
                      className="btn-green rounded-pill w-25 my-5"
                      type="submit"
                    >
                      บันทึก
                    </button>

                    <button
                      className="btn-red rounded-pill w-25 my-5"
                      type="button"
                      onClick={() => closemodalToggle(resetForm)}
                    >
                      ยกเลิก
                    </button>
                  </Form>
                </div>
              </Modal>
            </>
          );
        }}
      </Formik>

      <div className="boxes-tn">
        <div></div> <div></div> <div></div>
        <div></div> <div></div> <div></div>
        <div></div> <div></div> <div></div>
      </div>
    </Container>
  );
}
